import { Component, Host, Prop, h } from '@stencil/core';
import type { CssClassMap } from '../../helpers/utils/interfaces';
@Component({
  tag: 'cms-text-highlight',
  styleUrl: 'cms-text-highlight.scss',
  shadow: true,
})
export class CmsTextHighlight {
  /**
   * Text highlighting as campaign text highlighting is used
   * on landing pages or campaign pages
   */
  @Prop() useInCampaign: boolean;

  /**
   * set the content
   */
  @Prop({ mutable: true }) content: string;

  /**
   * set the accessible name
   */
  @Prop() accessibleName: string;

  private containerClass(): CssClassMap {
    return {
      'content-wrapper': true,
      campaign: this.useInCampaign,
    };
  }

  private renderTextHighlight() {
    if (!this.content) {
      return;
    }
    return <strong class='content-without-campaign' innerHTML={this.content} />;
  }

  private renderCampaignTextHighlight() {
    if (!this.content) {
      return;
    }
    return (
      <cms-headline
        style={{
          '--cms-spacing-top': '0',
          '--cms-spacing-bottom': '0',
          '--cms-grid-padding': '0',
        }}
        headlineText={this.content}
        headlineTag='h2'
        headlineClass='campaign-headline'
        headlinePosition='center'
        layout='full'
        isAdaptive
      />
    );
  }

  render() {
    const accessibilityAttributes = {};
    if (this.useInCampaign && this.accessibleName) {
      accessibilityAttributes['aria-label'] = this.accessibleName;
    }
    return (
      <Host>
        <div class={this.containerClass()} {...accessibilityAttributes}>
          {this.useInCampaign
            ? this.renderCampaignTextHighlight()
            : this.renderTextHighlight()}
        </div>
      </Host>
    );
  }
}
